import { useContext } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Stack } from '@startuptools/ui/Stack';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@startuptools/ui/Theme';
import { DownloadedContext } from '../contexts/DownloadedContext';
import { useSubscriptionStatus } from '../contexts/SubscriptionStatusContext';
import { useEmail } from '../contexts/EmailContext';
import { apiClient } from '../../common/http';
import GetAppIcon from '@mui/icons-material/GetApp';

export const TemplatesButton = ({
  text,
  tooltipTitle,
  url,
  docKinds,
}: {
  text: string;
  tooltipTitle: string;
  url: string[];
  docKinds: string[];
}) => {
  const { setDownloadedState } = useContext(DownloadedContext);
  const email = useEmail();
  const hasActiveSubValue = useSubscriptionStatus();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleClick = async () => {
    setDownloadedState(true);
    if (!email || !/^[^@]+@[^@]+\.[^@]+$/.test(email)) {
      return;
    }
    try {
      await apiClient.setHubspotTag(email, docKinds);
    } catch (e) {
      console.error(e);
    }
    try {
      await apiClient.setMailchimpTag(email, docKinds);
    } catch (e) {
      console.error(e);
    }
  };

  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  return (
    <Tooltip title={tooltipTitle} placement="right">
      {/*
       // @ts-expect-error TS2769 */}
      <Button
        type="button"
        onClick={() => handleClick()}
        href={hasActiveSubValue ? (url.length > 1 ? url[1] : url[0]) : url[0]}
        download
        className="w-fit "
        sx={{
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#E2E2E2',
          },
          '&:active': {
            boxShadow: 'none',
          },
          borderRadius: '0px',
          backgroundColor: '#ebebeb',
          color: '#000000',
          padding: '0.25rem 0.5rem',
          alignItems: 'center',
          justifyContent: 'start',
          display: 'inline-block',
        }}
      >
        <Stack spacing={2} direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontSize="0.875rem" whiteSpace={'nowrap'}>
            {isMobile ? truncateText(text, 30) : text}
          </Typography>
          <GetAppIcon fontSize={'inherit'} sx={{ width: '1rem', height: '1rem' }} aria-label="Download" />
        </Stack>
      </Button>
    </Tooltip>
  );
};
